<button (click)="loadAccounts()" style="display: none" id="resetCarrierFilter">
  Reset
</button>
<div class="col-12" *ngIf="isLoading">
  <app-busy [message]="message"></app-busy>
</div>
<div class="container-fluid">
  <div [ngClass]="{ 'is-phone-portrait': isPhonePortrait }">
    <div id="ca_landing_main_div">
      <div class="row"></div>
      <div class="page_header mt-20">
        <h1 class="heading">
          Accounts for {{ user?.FirstName }} {{ user?.LastName }}
        </h1>
        <p class="username">{{ user?.UserName }}</p>
      </div>
      <div class="row" style="margin: 15px 0" style="display: none">
        <div class="col-md-2">
          <div class="link-wrap">
            <img
              _ngcontent-uxm-c130=""
              class="action-icons"
              src="../../../assets/newimg/folder-dublicate-fill@2x.svg"
            />
            <span
              class="ocas-links"
              (click)="onClickOCASLinks('AUDIT')"
              id="ocasAuditBtn"
              >OCAS AUDIT</span
            >
          </div>
        </div>
        <div class="col-md-2">
          <div class="link-wrap">
            <img
              class="action-icons"
              src="../../../assets/newimg/folder-dublicate-fill@2x.svg"
            />
            <span class="ocas-links" id="annualComplianceBtn"
              >Annual Compliance</span
            >
          </div>
        </div>
      </div>
      <div>
        <div>
          <app-filter></app-filter>

          <app-actions
            [actions]="actions"
            [selectedcarrier]="selectedcarrier"
            [user]="user"
            *ngIf="listAccounts.length > 0"
            (actionEvent)="doAction($event)"
          ></app-actions>
        </div>
        <div class="actions screen" style="display: none">
          <div class="container" class="overlap-group3">
            <div class="row">
              <div
                *ngIf="
                  selectedcarrier != null &&
                  (selectedcarrier.status_code == 'Submitted_1' ||
                    selectedcarrier.status_code == 'Approved')
                "
                class="col-sm"
              >
                <a
                  [routerLink]=""
                  class="btn btn-default"
                  id="actionPermit"
                  value="0"
                  (click)="actionClicked(0, selectedcarrier)"
                >
                  <img
                    src="../assets/newimg/folder-dublicate-fill@2x.svg"
                    width="24"
                    height="24"
                  />
                  <span class="hidden-xs hidden-sm">My Permits</span>
                </a>
              </div>
              <div
                *ngIf="
                  selectedcarrier != null &&
                  (selectedcarrier.status_code == 'Submitted_1' ||
                    selectedcarrier.status_code == 'Approved')
                "
                class="col-sm"
              >
                <a
                  [routerLink]=""
                  class="btn btn-default"
                  id="actionApplication"
                  value="'0'"
                  (click)="actionClicked(1, selectedcarrier)"
                >
                  <img
                    src="../assets/newimg/folder-dublicate-fill@2x.svg"
                    width="24"
                    height="24"
                  />
                  <span class="hidden-xs hidden-sm">My Applications</span>
                </a>
              </div>
              <div
                *ngIf="
                  selectedcarrier != null &&
                  (selectedcarrier.status_code == 'Saved_1' ||
                    selectedcarrier.status_code == 'Submitted_1' ||
                    selectedcarrier.status_code == 'Approved' ||
                    selectedcarrier.status_code == 'AddInfo_1')
                "
                class="col-sm"
              >
                <a
                  [routerLink]=""
                  class="btn btn-default"
                  id="actionViewAccount"
                  value="'0'"
                  (click)="actionClicked(2, selectedcarrier)"
                >
                  <img
                    src="../assets/newimg/folder-dublicate-fill@2x.svg"
                    width="24"
                    height="24"
                  />
                  <span class="hidden-xs hidden-sm">View Account</span>
                </a>
              </div>
              <div
                *ngIf="
                  selectedcarrier != null &&
                  (selectedcarrier.status_code == 'Saved_1' ||
                    selectedcarrier.status_code == 'Submitted_1' ||
                    selectedcarrier.status_code == 'Approved' ||
                    selectedcarrier.status_code == 'AddInfo_1')
                "
                class="col-sm"
              >
                <a
                  [routerLink]=""
                  class="btn btn-default"
                  id="actionEditAccount"
                  value="'0'"
                  (click)="actionClicked(3, selectedcarrier)"
                >
                  <img
                    src="../assets/newimg/folder-dublicate-fill@2x.svg"
                    width="24"
                    height="24"
                  />
                  <span class="hidden-xs hidden-sm">Edit Account</span>
                </a>
              </div>
              <div
                *ngIf="
                  selectedcarrier != null &&
                  selectedcarrier.lead_user_id == user.Id &&
                  (selectedcarrier.status_code == 'Saved_1' ||
                    selectedcarrier.status_code == 'AddInfo_1')
                "
                class="col-sm"
              >
                <!--                <a-->
                <!--                  [routerLink]=""-->
                <!--                  class="btn btn-default"-->
                <!--                  id="myPermits"-->
                <!--                  value="'0'"-->
                <!--                  (click)="actionClicked($event, 4, selectedcarrier)"-->
                <!--                >-->
                <!--                  selectedcarrier-->
                <!--                  <img-->
                <!--                    src="../assets/newimg/folder-dublicate-fill@2x.svg"-->
                <!--                    width="24"-->
                <!--                    height="24"-->
                <!--                  />-->
                <!--                  <span class="hidden-xs hidden-sm">Delete Account</span>-->
                <!--                </a>-->
              </div>
              <div
                *ngIf="
                  selectedcarrier != null &&
                  (selectedcarrier.status_code == 'Submitted_1' ||
                    selectedcarrier.status_code == 'Approved')
                "
                class="col-sm"
              >
                <a
                  [routerLink]=""
                  class="btn btn-default"
                  id="actionUnSubmit"
                  value="'0'"
                  (click)="actionClicked(5, selectedcarrier)"
                >
                  <img
                    src="../assets/newimg/folder-dublicate-fill@2x.svg"
                    width="24"
                    height="24"
                  />
                  <span class="hidden-xs hidden-sm">Unsubmit</span>
                </a>
              </div>
              <div
                *ngIf="
                  selectedcarrier != null &&
                  (selectedcarrier.status_code == 'Submitted_1' ||
                    selectedcarrier.status_code == 'Approved')
                "
                class="col-sm"
              >
                <a
                  [routerLink]=""
                  class="btn btn-default"
                  id="actionAccountStatement"
                  value="'0'"
                  (click)="actionClicked(6, selectedcarrier)"
                >
                  <img
                    src="../assets/newimg/folder-dublicate-fill@2x.svg"
                    width="24"
                    height="24"
                  />
                  <span class="hidden-xs hidden-sm">Account Statement</span>
                </a>

                <a
                  [routerLink]=""
                  class="btn btn-default"
                  id="actionOCAS"
                  value="'0'"
                  (click)="actionClicked(10, selectedcarrier)"
                >
                  <img
                    src="../assets/newimg/folder-dublicate-fill@2x.svg"
                    width="24"
                    height="24"
                  />
                  <span class="hidden-xs hidden-sm">OCAS</span>
                </a>
              </div>
              <div class="col-sm">
                <a
                  [routerLink]=""
                  class="btn btn-default"
                  id="actionConsultants"
                  value="'0'"
                  (click)="actionClicked(7, selectedcarrier)"
                >
                  selectedcarrier
                  <img
                    src="../assets/newimg/folder-dublicate-fill@2x.svg"
                    width="24"
                    height="24"
                  />
                  <span class="hidden-xs hidden-sm">Appoint Consultants</span>
                </a>
              </div>
              <div
                *ngIf="
                  selectedcarrier != null &&
                  selectedcarrier.status_code == 'Approved'
                "
                class="col-sm"
              >
                <a
                  [routerLink]=""
                  class="btn btn-default"
                  id="actionCompliance"
                  value="'0'"
                  (click)="actionClicked(8, selectedcarrier)"
                >
                  <img
                    src="../assets/newimg/folder-dublicate-fill@2x.svg"
                    width="24"
                    height="24"
                  />
                  <span class="hidden-xs hidden-sm">Annual Compliance</span>
                </a>
              </div>

              <div
                *ngIf="
                  selectedcarrier != null &&
                  selectedcarrier.status_code == 'Approved'
                "
                class="col-sm"
              >
                <a
                  [routerLink]=""
                  class="btn btn-default"
                  id="fundMyAccount"
                  value="'0'"
                  (click)="actionClicked(9, selectedcarrier)"
                >
                  <img
                    src="../assets/newimg/folder-dublicate-fill@2x.svg"
                    width="24"
                    height="24"
                  />
                  <span class="hidden-xs hidden-sm">Fund My Account</span>
                </a>
              </div>
              <div *ngIf="selectedcarrier != null" class="col-sm">
                <a
                  [routerLink]=""
                  class="btn btn-default"
                  id="ocausdata"
                  value="'0'"
                  (click)="actionClicked(10, selectedcarrier)"
                >
                  <img
                    src="../assets/newimg/folder-dublicate-fill@2x.svg"
                    width="24"
                    height="24"
                  />
                  <span class="hidden-xs hidden-sm">Ocaus</span>
                </a>
              </div>
              <div *ngIf="selectedcarrier != null" class="col-sm">
                <a
                  [routerLink]=""
                  class="btn btn-default"
                  id="MyPermitBtn"
                  value="'0'"
                  (click)="actionClicked(11, selectedcarrier)"
                >
                  <img
                    src="../assets/newimg/folder-dublicate-fill@2x.svg"
                    width="24"
                    height="24"
                  />
                  <span class="hidden-xs hidden-sm">My Permits</span>
                </a> </div>
                <div *ngIf="selectedcarrier != null" class="col-sm">
                <a
                [routerLink]=""
                class="btn btn-default"
                id="monthlyCompliance"
                value="'0'"
                (click)="actionClicked(12, selectedcarrier)"
              >
                <img
                  src="../assets/newimg/folder-dublicate-fill@2x.svg"
                  width="24"
                  height="24"
                />
                <span class="hidden-xs hidden-sm">Monthly Compliance</span>
              </a>
            </div>

            <div *ngIf="selectedcarrier != null" class="col-sm">
              <a
              [routerLink]=""
              class="btn btn-default"
              id="carrierReports"
              value="'0'"
              (click)="actionClicked(13, selectedcarrier)"
            >
              <img
                src="../assets/newimg/folder-dublicate-fill@2x.svg"
                width="24"
                height="24"
              />
              <span class="hidden-xs hidden-sm">Carrier Reports</span>
            </a>
          </div>



            </div>
          </div>
          <div class="overlap-group3" style="display: none">
            <img
              class="border_color"
              src="../assets/newimg/border-color@2x.png"
              alt="border_color"
            />
            <div class="group-container">
              <div class="group-280"></div>
              <div class="overlap-group-group-container">
                <div class="change-route opensans-normal-sapphire-14px">
                  Change route
                </div>
                <img
                  class="pointers_fill"
                  src="../assets/newimg/pointers-fill@2x.svg"
                  alt="Pointers_fill"
                />
              </div>
              <div class="overlap-group-group-container">
                <div class="change-route opensans-normal-sapphire-14px">
                  Change routes
                </div>
                <img
                  class="pointers_fill"
                  src="../assets/newimg/pointers-fill@2x.svg"
                  alt="Pointers_fill"
                />
              </div>
              <div class="group-277">
                <div class="ic24-car">
                  <img
                    class="icon"
                    src="../assets/newimg/icon@2x.svg"
                    alt="Icon"
                  />
                </div>
                <div class="replace-vehicle opensans-normal-sapphire-14px">
                  Replace vehicle
                </div>
              </div>
              <!-- <div class="group-274">
                                <div class="date_range_fill">
                                    <div class="overlap-group-date_range_fill">
                                        <img class="rectangle-26" src="../assets/newimg/rectangle-26@2x.svg" alt="Rectangle 26" />
                                        <img class="line-1" src="../assets/newimg/line-1@2x.svg" alt="Line 1" />
                                        <img class="line-2" src="../assets/newimg/line-2@2x.svg" alt="Line 2" />
                                    </div>
                                    <img class="subtract-date_range_fill" src="../assets/newimg/subtract@2x.svg" alt="Subtract" />
                                </div>
                                <div class="apply-for-annual-compliance opensans-normal-sapphire-14px">Apply for annual compliance</div>
                            </div> -->
              <div class="group-279">
                <img
                  class="folder_dublicate_fill"
                  src="../assets/newimg/folder-dublicate-fill@2x.svg"
                  alt="Folder_dublicate_fill"
                />
                <div class="apply-for-duplicate opensans-normal-sapphire-14px">
                  Apply for duplicate
                </div>
              </div>
              <div class="overlap-group1">
                <div class="apply-for-change opensans-normal-sapphire-14px">
                  Apply for change
                </div>
                <div class="edit_fill">
                  <img
                    class="subtract-edit_fill"
                    src="../assets/newimg/subtract-1@2x.svg"
                    alt="Subtract"
                  />
                </div>
              </div>
              <!-- <div class="group-273">
                                <div class="credit-card_fill">
                                    <img class="subtract-credit-card_fill" src="../assets/newimg/subtract-2@2x.svg" alt="Subtract" />
                                </div>
                                <div class="pay-account opensans-normal-sapphire-14px">Pay account</div>
                            </div> -->
              <!-- <div class="group-275">
                                <div class="alarmclock_fill">
                                    <div class="overlap-group-alarmclock_fill">
                                        <img class="vector-65" src="../assets/newimg/vector-65@2x.svg" alt="Vector 65" />
                                        <img class="vector-66" src="../assets/newimg/vector-66@2x.svg" alt="Vector 66" />
                                        <img class="subtract-overlap-group" src="../assets/newimg/subtract-3@2x.svg" alt="Subtract" />
                                    </div>
                                </div>
                                <div class="change-timetable opensans-normal-sapphire-14px">Change timetable</div>
                            </div> -->
            </div>
            <!-- <div class="group-307">
                            <img class="vector" src="../assets/newimg/vector@2x.svg" alt="Vector" />
                            <div class="confirm-complete opensans-normal-sapphire-14px">Confirm &amp; complete</div>
                        </div>
                        <div class="group-308">
                            <img class="icon-star" src="../assets/newimg/icon-1@2x.svg" alt="icon-star" />
                            <div class="renew opensans-normal-sapphire-14px">Renew</div>
                        </div> -->
          </div>
        </div>
      </div>

      <div class="table-responsive" *ngIf="listAccounts.length > 0">
        <table class="table custom_table" cellspacing="0" width="100%">
          <thead>
            <tr>
              <th>Select</th>
              <th></th>
              <th class="th-sm">
                Account Number
                <i
                  style="vertical-align: middle"
                  class="fa fa-sort"
                  aria-hidden="true"
                  (click)="onSortClick('account_number', $event)"
                ></i>
              </th>
              <th class="th-sm">
                Account Name
                <i
                  style="vertical-align: middle"
                  class="fa fa-sort"
                  aria-hidden="true"
                  (click)="onSortClick('account_name', $event)"
                ></i>
              </th>
              <th class="th-sm">
                Parent Company
                <i
                  style="vertical-align: middle"
                  class="fa fa-sort"
                  aria-hidden="true"
                  (click)="onSortClick('main_comp_name', $event)"
                ></i>
              </th>
              <th class="text-right">
                Account Balance
                <i
                  style="vertical-align: middle"
                  class="fa fa-sort"
                  aria-hidden="true"
                  (click)="onSortClick('account_balance', $event)"
                ></i>
              </th>
              <th>
                Account Status
                <i
                  style="vertical-align: middle"
                  class="fa fa-sort"
                  aria-hidden="true"
                  (click)="onSortClick('status', $event)"
                ></i>
              </th>
              <th *ngIf="isPermit" class="text-center">Actions</th>
            </tr>
          </thead>
          <tbody *ngIf="listAccounts.length">
            <ng-container
              *ngFor="
                let acc of listAccounts
                  | paginate : { itemsPerPage: pageSize, currentPage: page };
                let i = index
              "
            >
              <tr>
                <td>
                  <input
                    type="checkbox"
                    value="{{ acc.id }}"
                    [ngModel]="selectedIndex === acc.id"
                    (change)="CheckedCarrier($event, acc.id, acc, acc.id)"
                  />
                </td>
                <td>
                  <i
                    class="fa fa-plus"
                    aria-hidden="true"
                    *ngIf="acc.subsidiaries.length > 0 && !acc.iscollapsed"
                    (click)="onCollapse(acc, i)"
                  ></i>
                  <i
                    class="fa fa-minus"
                    aria-hidden="true"
                    *ngIf="acc.subsidiaries.length > 0 && acc.iscollapsed"
                    (click)="onCollapse(acc, i)"
                  ></i>
                </td>
                <td>
                  <a
                    [routerLink]=""
                    (click)="actionClicked(2, acc)"
                    style="color: #00008b; text-decoration: underline"
                    ><span title="View account details">{{
                      acc.account_number
                    }}</span></a
                  >
                </td>
                <td>{{ acc.account_name }}</td>
                <td *ngIf="acc.main_comp_name">
                  {{ acc.main_comp_name }}
                </td>
                <td *ngIf="!acc.main_comp_name">None</td>
                <td class="text-right">
                  {{
                    acc.account_balance
                      ? (getOppositeSignValue(acc.account_balance) | currencyFormat)
                      : "R 0.00"
                  }}
                </td>
                <td style="margin-left: 5px">{{ acc.status }}</td>
                <td *ngIf="isPermit" class="text-center">
                  <span
                    id="edit"
                    title="Edit Account"
                    style="margin: 0%; margin-bottom: 7px"
                    class="btn btn-sm pull-center myButton"
                    (click)="actionClicked(3, acc)"
                  >
                    <img
                      src="/assets/newimg/border-color-13@2x.png"
                      class="permit-view"
                    />
                  </span>
                  <img
                    src="../../../../../assets/newimg/delete-30@2x.png"
                    title="Delete Account"
                    (click)="actionClicked(4, acc)"
                    style="cursor: pointer; width: 18px"
                  />

                  <span
                          id="apply"
                          title="Apply for A New Application"
                          style="margin: 0%; margin-bottom: 7px"
                          class="btn btn-sm pull-center myButton"
                          (click)="actionClicked(14, acc)"
                  >
                    <img
                            src="/assets/newimg/add-circle-4@2x.png"
                            class="permit-view"
                    />
                  </span>
                </td>
              </tr>
              <ng-container *ngIf="acc.subsidiaries.length && acc.iscollapsed">
                <tr *ngFor="let sub of acc.subsidiaries; let index = index">
                  <td>
                    <input
                      type="checkbox"
                      value="{{ sub.id }}"
                      [ngModel]="selectedIndex === sub.id"
                      (change)="CheckedCarrier($event, sub.id, sub, sub.id)"
                    />
                  </td>
                  <td></td>
                  <td>
                    <a
                      [routerLink]=""
                      (click)="actionClicked(2, acc)"
                      style="color: #00008b; text-decoration: underline"
                      ><span title="View account details">{{
                        sub.account_number
                      }}</span></a
                    >
                  </td>
                  <td>{{ sub.account_name }}</td>
                  <td *ngIf="sub.main_comp_name">
                    {{ sub.main_comp_name }}
                  </td>
                  <td *ngIf="!sub.main_comp_name">None</td>
                  <td>
                    {{
                      sub.account_balance
                        ? (sub.account_balance | currencyFormat)
                        : "R 0.00"
                    }}
                  </td>
                  <td style="margin-left: 5px">{{ sub.status }}</td>
                  <td *ngIf="isPermit">
                    <span
                      id="p"
                      title="Edit Account"
                      style="margin: 0%"
                      class="btn btn-sm pull-center myButton"
                      (click)="actionClicked(3, sub)"
                    >
                      <img
                        src="/assets/newimg/border-color-13@2x.png"
                        class="permit-view"
                      />
                    </span>
                  </td>
                </tr>
              </ng-container>
            </ng-container>
          </tbody>
        </table>
      </div>

      <!-- <div class="table-responsive" *ngIf="listAccounts.length > 0">
        <table class="table custom_table" cellspacing="0" width="100%">
          <thead>
            <tr>
              <th>Select</th>
              <th></th>
              <th class="th-sm">
                Account Number
                <i
                  style="vertical-align: middle"
                  class="fa fa-sort"
                  aria-hidden="true"
                  (click)="onSortClick('account_number', $event)"
                ></i>
              </th>
              <th class="th-sm">
                Account Name
                <i
                  style="vertical-align: middle"
                  class="fa fa-sort"
                  aria-hidden="true"
                  (click)="onSortClick('account_name', $event)"
                ></i>
              </th>
              <th class="th-sm">
                Parent Company
                <i
                  style="vertical-align: middle"
                  class="fa fa-sort"
                  aria-hidden="true"
                  (click)="onSortClick('main_comp_name', $event)"
                ></i>
              </th>
              <th>
                Account Balance
                <i
                  style="vertical-align: middle"
                  class="fa fa-sort"
                  aria-hidden="true"
                  (click)="onSortClick('account_balance', $event)"
                ></i>
              </th>
              <th>
                Account Status
                <i
                  style="vertical-align: middle"
                  class="fa fa-sort"
                  aria-hidden="true"
                  (click)="onSortClick('status', $event)"
                ></i>
              </th>
              <th *ngIf="isPermit">Edit Account</th>
            </tr>
          </thead>
          <tbody *ngIf="listAccounts.length">
            <ng-container
              *ngFor="
                let acc of listAccounts
                  | paginate : { itemsPerPage: 5, currentPage: page };
                let i = index
              "
            >
              <tr>
                <td>
                  <input
                    type="checkbox"
                    value="{{ acc.id }}"
                    [ngModel]="selectedIndex === acc.id"
                    (change)="CheckedCarrier($event, acc.id, acc, acc.id)"
                  />
                </td>
                <td>
                  <i
                    class="fa fa-plus"
                    aria-hidden="true"
                    *ngIf="acc.subsidiaries.length > 0 && !acc.iscollapsed"
                    (click)="onCollapse(acc, i)"
                  ></i>
                  <i
                    class="fa fa-minus"
                    aria-hidden="true"
                    *ngIf="acc.subsidiaries.length > 0 && acc.iscollapsed"
                    (click)="onCollapse(acc, i)"
                  ></i>
                </td>
                <td>
                  <a
                    [routerLink]=""
                    (click)="actionClicked(2, acc)"
                    style="color: #00008b; text-decoration: underline"
                    ><span title="View account details">{{
                      acc.account_number
                    }}</span></a
                  >
                </td>
                <td>{{ acc.account_name }}</td>
                <td *ngIf="acc.main_comp_name">
                  {{ acc.main_comp_name }}
                </td>
                <td *ngIf="!acc.main_comp_name">None</td>
                <td>
                  {{
                    acc.account_balance
                      ? (acc.account_balance | currencyFormat)
                      : "R 0.00"
                  }}
                </td>
                <td style="margin-left: 5px">{{ acc.status }}</td>
                <td *ngIf="isPermit">
                  <span
                    id="edit"
                    title="Edit Account"
                    style="margin: 0%"
                    class="btn btn-sm pull-center myButton"
                    (click)="actionClicked(3, acc)"
                  >
                    <img
                      src="/assets/newimg/border-color-13@2x.png"
                      class="permit-view"
                    />
                  </span>
                </td>
              </tr>
              <ng-container *ngIf="acc.subsidiaries.length && acc.iscollapsed">
                <tr *ngFor="let sub of acc.subsidiaries; let index = index">
                  <td>
                    <input
                      type="checkbox"
                      value="{{ sub.id }}"
                      [ngModel]="selectedIndex === sub.id"
                      (change)="CheckedCarrier($event, sub.id, sub, sub.id)"
                    />
                  </td>
                  <td></td>
                  <td>
                    <a
                      [routerLink]=""
                      (click)="actionClicked(2, acc)"
                      style="color: #00008b; text-decoration: underline"
                      ><span title="View account details">{{
                        sub.account_number
                      }}</span></a
                    >
                  </td>
                  <td>{{ sub.account_name }}</td>
                  <td *ngIf="sub.main_comp_name">
                    {{ sub.main_comp_name }}
                  </td>
                  <td *ngIf="!sub.main_comp_name">None</td>
                  <td>
                    {{
                      sub.account_balance
                        ? (sub.account_balance | currencyFormat)
                        : "R 0.00"
                    }}
                  </td>
                  <td style="margin-left: 5px">{{ sub.status }}</td>
                  <td *ngIf="isPermit">
                    <span
                      id="p"
                      title="Edit Account"
                      style="margin: 0%"
                      class="btn btn-sm pull-center myButton"
                      (click)="actionClicked(3, sub)"
                    >
                      <img
                        src="/assets/newimg/border-color-13@2x.png"
                        class="permit-view"
                      />
                    </span>
                  </td>
                </tr>
              </ng-container>
            </ng-container>
          </tbody>
        </table>
      </div> -->

      <div class="table_footer">
        <div class="row">
          <div class="col-2">
            <div
              class="input-group mb-3 rm-brd"
              *ngIf="listAccounts.length > 0"
              style="width: 125px !important; height: 30px !important"
            >
              <div class="input-group-prepend">
                <label
                  class="input-group-text form-control-sm show-h"
                  for="show-id"
                  >Show:</label
                >
              </div>
              <select
              
                class="form-control form-control-sm show-h"
                id="show-id"
                [(ngModel)]="pageSize"
                (change)="onChange(pageSize)"
              >
                <option *ngFor="let key of utility.pageItems" [ngValue]="key">
                  {{ key }}
                </option>
              </select>
            </div>
          </div>
        </div>
        
        <div class="column" style="margin: 0 auto !important">
          <span *ngIf="listAccounts.length == 0 && isLoading == false">
            <p
              style="
                text-align: center !important;
                margin-bottom: 15px;
                font-weight: bold;
              "
            >
              You currently don't have any accounts yet, please import existing
              accounts or create a new account.
            </p>
          </span>
          <div class="row">
            <div class="col no-mp" style="text-align: center">
              <button
                *ngIf="
                  this.router.url.indexOf('carrier/application-permit') == -1
                "
                class="btn hd-btn-close"
                data-toggle="modal"
                data-target="#myModal"
                title="Import existing carrier from legacy system"
                (click)="setCarrierCodeFocus()"
              >
                Import existing account
              </button>
              <button
                *ngIf="
                  this.router.url.indexOf('carrier/application-permit') == -1
                "
                class="btn hd-btn"
                [routerLink]="['/carrier/account/add']"
              >
                Create carrier account
              </button>
            </div>
          </div>
        </div>
        
        <div class="column pagination_row">
          <div *ngIf="listAccounts.length > 0">
            <pagination-controls
            previousLabel="Prev"
            nextLabel="Next"
            responsive="true"
            (pageChange)="pager($event)"
            style="float: right !important"
          ></pagination-controls>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <!--Manage Timetable-->
          <div
            class="modal fade"
            id="myModal"
            tabindex="-1"
            role="dialog"
            aria-hidden="true"
            style="margin: 12% auto"
          >
            <div
              class="modal-dialog modal-lg"
              role="document"
              style="margin-bottom: 0%; padding-bottom: 0%"
            >
              <div
                class="modal-content"
                style="
                  border-style: solid;
                  border-width: 1px;
                  border-color: #1d3f94;
                  padding: 0%;
                  background-color: #ffffff;
                "
              >
                <!-- <div class="modal-header">

              <button type="button" class="close" data-dismiss="modal" #closebutton aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div> -->
                <div class="modal-body modal-lg" style="height: 300px">
                  <!-- <label style="margin-top: 30px;margin-left:50px">Carrier Code : </label> -->
                  <!-- Import existing carrier from legacy system -->
                  <h5
                    style="text-align: center; margin-top: 12px; color: #1d3f94"
                  >
                    IMPORT CARRIER FROM LEGACY SYSTEM
                  </h5>
                  <br />
                  <div style="margin-left: 100px">
                    <input
                      type="text"
                      placeholder="Enter Account Number"
                      id="carrierCode"
                      name="carrierCode"
                      #carrierCode
                      (keypress)="checkKey($event)"
                      autofocus
                    />
                    <button
                      id="searchButton"
                      class="btn btn-sm m-clr"
                      style="color: white !important"
                      (click)="fetchCarrier(carrierCode.value)"
                    >
                      Search
                    </button>

                    <div>
                      <label *ngIf="emptyCarrier == true" style="color: red">{{
                        errorMessage
                      }}</label>
                    </div>
                    <div
                      *ngIf="fetchedCarrier == true"
                      style="margin-top: 30px"
                    >
                      <label
                        ><b>Carrier Name : </b
                        ><span style="font-weight: 200">{{
                          carrierName
                        }}</span></label
                      >
                    </div>
                    <div *ngIf="fetchedCarrier == true">
                      <label
                        ><b>Trading Name : </b
                        ><span style="font-weight: 200">{{
                          carrierTradingName
                        }}</span></label
                      >
                    </div>
                    <div *ngIf="fetchedCarrier == true">
                      <label
                        ><b>Carrier Type : </b
                        ><span style="font-weight: 200">{{
                          carrierType
                        }}</span></label
                      >
                    </div>
                    <div *ngIf="fetchedCarrier == true">
                      <label
                        ><b>Country : </b
                        ><span style="font-weight: 200">{{
                          carrierCountry
                        }}</span></label
                      >
                    </div>
                  </div>
                </div>
                <div class="modal-footer" style="height: 65px; padding: 0%">
                  <div clas="row">
                    <div class="col-12" style="padding: 0%">
                      <button
                        type="button"
                        class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2"
                        style="color: white !important"
                        (click)="cancelCarrier()"
                        data-dismiss="modal"
                      >
                        Close
                      </button>
                      <button
                        type="button"
                        class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2"
                        style="color: white !important"
                        (click)="importCarrier()"
                        [disabled]="!fetchedCarrier"
                        data-dismiss="modal"
                      >
                        Import
                      </button>
                      <label
                        *ngIf="fetchedCarrier == true"
                        style="
                          color: #1d3f94;
                          padding-right: 60px;
                          padding-top: 15px;
                        "
                        >Confirm the carrier information is correct, then click
                        the "Import" button ...</label
                      >
                      <!-- <button type="button" class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2" data-dismiss="modal">Cancel</button> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
